import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import validSupergitHIS from '../../api/validSupergitHIS'
import toast from 'react-hot-toast'

export const createTransaction = createAsyncThunk(
  'createTransaction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post('createTransaction', data)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.error || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.error || 'something went wrong'
      )
    }
  }
)

export const getTransactions = createAsyncThunk(
  'getTransactions',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post('listTransactions', data)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.message || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)
export const deleteTransactions = createAsyncThunk(
  'deleteTransactions',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post('deleteEntry', data)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.error || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)
export const searchTransaction = createAsyncThunk(
  'searchTransaction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post('searchTransactions', data)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.message || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)
export const searchDatedTransaction = createAsyncThunk(
  'searchDatedTransaction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post(
        'searchTransactionsByDate',
        data
      )
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.message || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)
export const updateTransaction = createAsyncThunk(
  'updateTransaction',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post(
        `updateTransactions/${id}`,
        data
      )
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.error || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)
export const getTransactionEntries = createAsyncThunk(
  'getTransactionEntries',
  async (id, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post(`transaction_entry/${id}`)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.message || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)
export const getTransactionEntriesNUmber = createAsyncThunk(
  'getTransactionEntriesnNumber',
  async (id, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post(
        `transaction_entry_number/${id}`
      )
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.message || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)

export const postTransaction = createAsyncThunk(
  'postTransaction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post('postTransaction', data)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.error || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.error || 'something went wrong'
      )
    }
  }
)

export const getJournalEntryAuditLogs = createAsyncThunk(
  'getJournalEntryAuditLogs',
  async (journalEntryNumber, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.get(
        `journal-entry-audit-logs/${encodeURIComponent(journalEntryNumber)}`
      )
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.message || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)

export const createTransactionDraft = createAsyncThunk(
  'createTransactionDraft',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post('createTransaction', data)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.error || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.error || 'something went wrong'
      )
    }
  }
)

export const getTransactionsDraft = createAsyncThunk(
  'getTransactionsDraft',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.get('getTransactionsDraft')
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.message || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)

export const deleteTransactionDraft = createAsyncThunk(
  'deleteTransactionDraft',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.delete('deleteTransactionDraft', data)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.error || 'something went wrong')
      return rejectWithValue(
        error?.response?.data?.message || 'something went wrong'
      )
    }
  }
)

export const redoTransaction = createAsyncThunk(
  'redoTransaction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post('redoEntry', data)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.error || 'something went wrong')
      return rejectWithValue(error?.response?.data?.error || 'something went wrong')
    }
  }
)

export const undoTransaction = createAsyncThunk(
  'undoTransaction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post('redoEntry', data)
      return response.data
    } catch (error) {
      toast.error(error?.response?.data?.error || 'something went wrong')
      return rejectWithValue(error?.response?.data?.error || 'something went wrong')
    }
  }
)


const initialState = {
  isLoading: false,
  transactions: [],
  page: 1,
  per_page: 10,
  total_pages: 0,
  total_record: 0,
  entries: [],
  accStatementEntries: [],
  auditLogs: [],
  auditLogsLoading: false,
  draft: null
}



const TransactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    resetEntries: (state, action) => {
      state.entries = []
    }
  },
  extraReducers: builder => {
    builder.addCase(createTransaction.pending, state => {
      state.isLoading = true
    })
    builder.addCase(createTransaction.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
      toast.success(action.payload.message || 'Successful')
    })
    builder.addCase(createTransaction.rejected, (state, action) => {
      state.isLoading = false
      // toast.error(action.error.message);
    })

    builder.addCase(postTransaction.pending, state => {
      state.isLoading = true
    })
    builder.addCase(postTransaction.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
      toast.success(action.payload.message || 'Successful')
    })
    builder.addCase(postTransaction.rejected, state => {
      state.isLoading = false
    })

    builder.addCase(deleteTransactions.pending, state => {
      state.isLoading = true
    })
    builder.addCase(deleteTransactions.fulfilled, (state, action) => {
      state.isLoading = false
      toast.success(action.payload?.message || 'Successful')
    })
    builder.addCase(deleteTransactions.rejected, (state, action) => {
      state.isLoading = false
    })

    builder.addCase(getTransactions.pending, state => {
      state.isLoading = true
    })
    builder.addCase(getTransactions.fulfilled, (state, action) => {
      state.isLoading = false
      state.transactions = action.payload.data
      state.page = action.payload.page
      state.per_page = action.payload.per_page
      state.total_pages = action.payload.total_pages
      state.total_record = action.payload.total_record
    })
    builder.addCase(getTransactions.rejected, (state, action) => {
      state.isLoading = false
      toast.error(action.error.message)
    })
    builder.addCase(searchTransaction.pending, state => {
      state.isLoading = true
    })
    builder.addCase(searchTransaction.fulfilled, (state, action) => {
      state.transactions = action.payload.data
      state.page = action.payload.page
      state.per_page = action.payload.per_page
      state.total_pages = action.payload.total_pages
      state.isLoading = false
      state.total_record = action.payload.total_record
    })
    builder.addCase(searchTransaction.rejected, (state, action) => {
      state.isLoading = false
      toast.error(action.error.message)
    })
    builder.addCase(searchDatedTransaction.pending, state => {
      state.isLoading = true
    })
    builder.addCase(searchDatedTransaction.fulfilled, (state, action) => {
      state.transactions = action.payload.data
      state.page = action.payload.page
      state.per_page = action.payload.per_page
      state.total_pages = action.payload.total_pages
      state.isLoading = false
      state.total_record = action.payload.total_record
    })
    builder.addCase(searchDatedTransaction.rejected, (state, action) => {
      state.isLoading = false
      toast.error(action.error.message)
    })
    builder.addCase(updateTransaction.pending, state => {
      state.isLoading = true
    })
    builder.addCase(updateTransaction.fulfilled, (state, action) => {
      state.isLoading = false
      toast.success(action?.payload?.message)
    })
    builder.addCase(updateTransaction.rejected, (state, action) => {
      state.isLoading = false
      // toast.error(action.error.message);
    })
    builder.addCase(getTransactionEntries.pending, state => {
      state.isLoading = true
    })
    builder.addCase(getTransactionEntries.fulfilled, (state, action) => {
      state.isLoading = false
      state.entries = action?.payload?.data
    })
    builder.addCase(getTransactionEntries.rejected, (state, action) => {
      state.isLoading = false
    })
    builder.addCase(getTransactionEntriesNUmber.pending, state => {
      state.isLoading = true
    })
    builder.addCase(getTransactionEntriesNUmber.fulfilled, (state, action) => {
      state.isLoading = false
      state.accStatementEntries = action?.payload?.data
    })
    builder.addCase(getTransactionEntriesNUmber.rejected, (state, action) => {
      state.isLoading = false
    })
    builder.addCase(getJournalEntryAuditLogs.pending, state => {
      state.auditLogsLoading = true
      state.auditLogs = []
    })
    builder.addCase(getJournalEntryAuditLogs.fulfilled, (state, action) => {
      state.auditLogsLoading = false
      state.auditLogs = [...(action?.payload?.data || [])].sort(
        (a, b) => new Date(b?.created_at || 0) - new Date(a?.created_at || 0)
      )
    })
    builder.addCase(getJournalEntryAuditLogs.rejected, state => {
      state.auditLogsLoading = false
      state.auditLogs = []
    })

    builder.addCase(createTransactionDraft.pending, state => {
      state.isLoading = true
    })
    builder.addCase(createTransactionDraft.fulfilled, (state, action) => {
      state.isLoading = false
      toast.success(action.payload.message || 'Draft saved successfully')
    })
    builder.addCase(createTransactionDraft.rejected, (state, action) => {
      state.isLoading = false
    })

    builder.addCase(getTransactionsDraft.pending, state => {
      state.isLoading = true
    })
    builder.addCase(getTransactionsDraft.fulfilled, (state, action) => {
      state.isLoading = false
      state.draft = action.payload.data
    })
    builder.addCase(getTransactionsDraft.rejected, (state, action) => {
      state.isLoading = false
    })


    builder.addCase(deleteTransactionDraft.pending, state => {
      state.isLoading = true
    })
    builder.addCase(deleteTransactionDraft.fulfilled, (state, action) => {
      state.isLoading = false
      console.log(action.payload?.message || 'Draft deleted successfully')
    })
    builder.addCase(deleteTransactionDraft.rejected, (state, action) => {
      state.isLoading = false
    })

    builder.addCase(redoTransaction.pending, state => { state.isLoading = true })
    builder.addCase(redoTransaction.fulfilled, (state, action) => {
      state.isLoading = false
      toast.success(action.payload?.message || 'Restored successfully')
    })
    builder.addCase(redoTransaction.rejected, state => { state.isLoading = false })

    builder.addCase(undoTransaction.pending, state => { state.isLoading = true })
    builder.addCase(undoTransaction.fulfilled, (state, action) => {
      state.isLoading = false
      toast.success(action.payload?.message || 'Reversed successfully')
    })
    builder.addCase(undoTransaction.rejected, state => { state.isLoading = false })

  }
})

export default TransactionsSlice.reducer
export const { resetEntries } = TransactionsSlice.actions 
